import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useMemo} from 'react';
import {isProductFineAndRare} from 'modules/product-card/helpers';

export const useIsProductFineAndRare = () => {
    const productData = useAppSelector(selectProductData);

    return useMemo(() => {
        return isProductFineAndRare(productData);
    }, [productData]);
};
